/* SPDX-FileCopyrightText: 2014-present Kriasoft <hello@kriasoft.com> */
/* SPDX-License-Identifier: MIT */

export function useSignOut(): () => void {
  return () => {
    console.log("Sign out");
  };
}
